var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDraggableDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 21,
    viewBox: "0 0 12 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "draggable-dots"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.5 15.5905C1.4 15.5905 0.5 16.5513 0.5 17.7256C0.5 18.8999 1.4 19.8606 2.5 19.8606C3.6 19.8606 4.5 18.8999 4.5 17.7256C4.5 16.5513 3.6 15.5905 2.5 15.5905ZM9.5 4.91516C10.6 4.91516 11.5 3.95438 11.5 2.78009C11.5 1.6058 10.6 0.64502 9.5 0.64502C8.4 0.64502 7.5 1.6058 7.5 2.78009C7.5 3.95438 8.4 4.91516 9.5 4.91516ZM2.5 8.11776C1.4 8.11776 0.5 9.07854 0.5 10.2528C0.5 11.4271 1.4 12.3879 2.5 12.3879C3.6 12.3879 4.5 11.4271 4.5 10.2528C4.5 9.07854 3.6 8.11776 2.5 8.11776ZM9.5 8.11776C8.4 8.11776 7.5 9.07854 7.5 10.2528C7.5 11.4271 8.4 12.3879 9.5 12.3879C10.6 12.3879 11.5 11.4271 11.5 10.2528C11.5 9.07854 10.6 8.11776 9.5 8.11776ZM9.5 15.5905C8.4 15.5905 7.5 16.5513 7.5 17.7256C7.5 18.8999 8.4 19.8606 9.5 19.8606C10.6 19.8606 11.5 18.8999 11.5 17.7256C11.5 16.5513 10.6 15.5905 9.5 15.5905ZM2.5 0.64502C1.4 0.64502 0.5 1.6058 0.5 2.78009C0.5 3.95438 1.4 4.91516 2.5 4.91516C3.6 4.91516 4.5 3.95438 4.5 2.78009C4.5 1.6058 3.6 0.64502 2.5 0.64502Z",
    fill: "#BBBBBB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraggableDots);
export default __webpack_public_path__ + "static/media/draggable-dots.f3710e41fa5e4d96f14a9984a6f72b9d.svg";
export { ForwardRef as ReactComponent };